// extracted by mini-css-extract-plugin
export default {"chart":"_2JeZ"};